import { useCallback, useEffect, useState } from "react";
import { Spin, Table, Tag } from "antd";
import type { TableColumnsType } from "antd";
import { AdminListShell } from "../components/admin/AdminListShell";
import { fetchAdminEmailVerificationPage } from "../api/client";
import type { AdminEmailVerificationRow } from "../api/types";
import { fmtDateTime } from "../lib/formatAdmin";

export function EmailVerificationPage() {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [items, setItems] = useState<AdminEmailVerificationRow[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState<"forbidden" | "error" | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setErr(null);
    const r = await fetchAdminEmailVerificationPage({ page, page_size: pageSize });
    if (r === "forbidden") setErr("forbidden");
    else if (r === "error") setErr("error");
    else {
      setItems(r.items);
      setTotal(r.total);
    }
    setLoading(false);
  }, [page, pageSize]);

  useEffect(() => {
    void load();
  }, [load]);

  const columns: TableColumnsType<AdminEmailVerificationRow> = [
    { title: "邮箱（脱敏）", dataIndex: "email_masked", key: "em", width: 200, ellipsis: true },
    { title: "场景", dataIndex: "scene", key: "sc", width: 100, render: (s) => <Tag>{s}</Tag> },
    {
      title: "请求 IP",
      dataIndex: "request_ip",
      key: "ip",
      width: 130,
      render: (v) => v ?? "—",
    },
    { title: "尝试次数", dataIndex: "attempt_count", key: "ac", width: 88, align: "right" },
    { title: "创建", dataIndex: "created_at", width: 158, render: fmtDateTime },
    { title: "过期", dataIndex: "expires_at", width: 158, render: fmtDateTime },
    { title: "使用时间", dataIndex: "used_at", width: 158, render: fmtDateTime },
  ];

  return (
    <AdminListShell
      title="验证码记录"
      description="邮箱验证码请求与核销轨迹（邮箱已脱敏）。"
      err={err}
      errorBanner
      table={(bodyY) => (
        <div className="admin-ledger-table-wrap admin-ledger-table-wrap--flex">
          <Spin spinning={loading}>
            <Table<AdminEmailVerificationRow>
              rowKey="id"
              className="admin-ledger-table"
              columns={columns}
              dataSource={items}
              pagination={{
                current: page,
                pageSize,
                total,
                showSizeChanger: true,
                pageSizeOptions: [10, 20, 50],
                showTotal: (t) => `共 ${t} 条`,
                onChange: (p, ps) => {
                  setPage(p);
                  setPageSize(ps);
                },
              }}
              scroll={{ x: 1100, y: bodyY }}
              locale={{ emptyText: "暂无记录" }}
            />
          </Spin>
        </div>
      )}
    />
  );
}
